import React, { lazy, Suspense } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import store from './REDUX/rootReducer/store';
// import { deep_copy } from './utils/object';
// import Config from './config';
// import APP from './app';
// import Publisher from './publisher';
// import state from './state';
// import Main from './Main';

const Main = lazy(() => import('./Main'));

// Initialization logic
// APP.config = new Config();
// window.APP = APP;
// APP.state = new Publisher(deep_copy(state));


const AppWrapper = () => {

    return (
        <Suspense fallback={<div className="loader_wrap"><img src="/media/images/loaders/loader.gif" alt="Loading..." /></div>}>
            <Provider store={store}>
                <HelmetProvider>
                    <BrowserRouter>
                        <Main />
                    </BrowserRouter>
                </HelmetProvider>
            </Provider>
        </Suspense>
    );
};

export default AppWrapper;